(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shop-look-article"]) return;
  try {
    
  class ShopLookArticle extends HTMLElement {
    constructor() {
      super();

      this.slide = this.querySelector('.js-shop-look-slide');
      
      this.slideInit = $(this.slide).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
      });
    }
  }
  customElements.define('shop-look-article', ShopLookArticle);
  
  class ShopLookCell extends HTMLElement {
    constructor() {
      super();

      this.lookbookbutton = this.querySelector('.js-button-shop-look');
      this.lookbookproducts = this.querySelector('.shop-look-cell-products-wrap');
      this.slide = document.querySelector('.js-shop-look-slide');
      this.close = this.querySelector('.shop-look-cell-content-close');

      this.lookbookbutton.addEventListener("click", () => {
        this.lookbookproducts.classList.add('active');
        $(this.slide).slick("slickSetOption", "draggable", false);
        $(this.slide).slick("slickSetOption", "swipe", false);
        $(this.slide).slick("slickSetOption", "touchMove", false);
      })

      window.addEventListener('click', ({ target }) => { 
        if(!target.classList.contains('js-button-shop-look')){          
          const products = target.closest('.shop-look-cell-products-wrap');
          const clickedOnClosedproducts = products;
  
          if (clickedOnClosedproducts) {
            if(target.closest('.shop-look-cell-content-close') || target.classList.contains('shop-look-cell-content-close')){
              this.lookbookproducts.classList.remove('active');
              $(this.slide).slick("slickSetOption", "draggable", true);
              $(this.slide).slick("slickSetOption", "swipe", true);
              $(this.slide).slick("slickSetOption", "touchMove", true);
            }  
          }else{
            this.lookbookproducts.classList.remove('active');
            $(this.slide).slick("slickSetOption", "draggable", true);
            $(this.slide).slick("slickSetOption", "swipe", true);
            $(this.slide).slick("slickSetOption", "touchMove", true);
          }
        }
      })
    }
  }
  
  customElements.define('shop-look-cell', ShopLookCell);

  } catch(e) { console.error(e); }
})();
})();
